import { SyntheticEvent } from 'react';

import {
  ActionCreatorWithoutPayload,
  ActionCreatorWithPayload,
} from '@reduxjs/toolkit';

import { ItemLabelModel } from '../../../../features/shared/components/dropdown/models/dropdown-props.model';
import { ResetConfigModel } from '../../../../features/shared/models/reset-config.model';
import { GetStringKeys } from '../../../../features/shared/types/get-string-keys.type';
import { useAppDispatch } from '../../../../store/hooks';

export const useBaseAutocompleteOnChange = <T>(
  propertyName: GetStringKeys<T>,
  dispatchFn: ActionCreatorWithPayload<number | undefined, string>,
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void,
  resetConfig?: ResetConfigModel<T>[],
  stateResetFn?: ActionCreatorWithoutPayload
): ((
  event: SyntheticEvent<Element, Event>,
  newValue: ItemLabelModel<number> | null
) => void) => {
  const dispatch = useAppDispatch();

  return (
    event: SyntheticEvent<Element, Event>,
    value: ItemLabelModel<number> | null
  ): void => {
    setFieldValue(propertyName, value);

    resetConfig?.forEach(config =>
      setFieldValue(config.fieldName, config.valueToReset)
    );

    if (stateResetFn) {
      dispatch(stateResetFn());
    }

    dispatch(dispatchFn(value?.id));
  };
};
